<template>
  <BaseFormCard ref="search-form-card" width="600" icon="search" :setActive="true">
    <template #title>ค้นหาข้อมูลอุบัติเหตุ</template>
    <template #body>
      <v-tabs v-model="searchTab" fixed-tabs hide-slider>
        <v-tab class="ml-0">ค้นหาข้อมูลอุบัติเหตุ</v-tab>
        <v-tab>ข้อมูลอุบัติเหตุย้อนหลัง 7 วัน</v-tab>
      </v-tabs>

      <v-tabs-items v-model="searchTab">
        <v-tab-item class="pa-5">
          <v-btn-toggle v-model="peroidToggle" mandatory class="peroid-toggle" color="#4f3f40">
            <v-btn
              small
              text
              value="date"
              active-class="toggle-active"
              class="toggle-normal subtitle-2"
              >ระบุวันที่</v-btn
            >
            <v-btn
              small
              text
              value="event"
              active-class="toggle-active"
              class="toggle-normal subtitle-2"
              >เทศกาล</v-btn
            >
          </v-btn-toggle>

          <v-layout row wrap ma-0>
            <v-flex xs12 v-show="peroidToggle == 'date'">
              <v-layout row wrap ma-0>
                <v-flex xs6 pr-2>
                  <p class="subtitle-2 mt-10 mb-2">วันที่เริ่มต้น</p>
                  <DatePicker
                    v-model="startDate"
                    ref="startDate"
                    :max="today"
                    @input="changeDate(utils.startDateChanged(startDate, endDate))"
                  />
                </v-flex>
                <v-flex xs6 pl-2>
                  <p class="subtitle-2 mt-10 mb-2">วันที่สิ้นสุด</p>
                  <DatePicker
                    v-model="endDate"
                    ref="endDate"
                    :max="today"
                    @input="changeDate(utils.endDateChanged(startDate, endDate))"
                  />
                </v-flex>
                <!-- <v-flex xs6 pr-2>
                  <p class="subtitle-2 mt-10 mb-2">จังหวัด</p>
                  <v-select
                    v-model="provinceSelect"
                    :items="provinceItems"
                    item-text="name"
                    item-value="id"
                    no-data-text="ไม่พบข้อมูล"
                    label="เลือกจังหวัด"
                    class="card-border"
                    flat
                    solo
                    hide-details
                  ></v-select>
                </v-flex>-->
                <v-flex
                  :class="{
                    xs12: $vuetify.breakpoint.width <= 700,
                    'xs4 pr-1': $vuetify.breakpoint.width > 700
                  }"
                >
                  <p class="subtitle-2 my-2">จังหวัด</p>
                  <v-select
                    v-model="provinceSelect"
                    :items="provinceItems"
                    item-text="name"
                    item-value="id"
                    no-data-text="ไม่พบข้อมูล"
                    label="เลือกจังหวัด"
                    class="card-border"
                    flat
                    solo
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex
                  :class="{
                    xs12: $vuetify.breakpoint.width <= 700,
                    'xs4 pr-1': $vuetify.breakpoint.width > 700
                  }"
                >
                  <p class="subtitle-2 my-2">อำเภอ</p>
                  <v-select
                    v-model="amphoeSelect"
                    :items="amphoeItems"
                    item-text="name"
                    item-value="id"
                    no-data-text="ไม่พบข้อมูล"
                    label="เลือกอำเภอ"
                    class="card-border"
                    flat
                    solo
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex
                  :class="{
                    xs12: $vuetify.breakpoint.width <= 700,
                    xs4: $vuetify.breakpoint.width > 700
                  }"
                >
                  <p class="subtitle-2 my-2">ตำบล</p>
                  <v-select
                    v-model="tambonSelect"
                    :items="tambonItems"
                    item-text="name"
                    item-value="id"
                    no-data-text="ไม่พบข้อมูล"
                    label="เลือกตำบล"
                    class="card-border"
                    flat
                    solo
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <p class="subtitle-2 mt-10 mb-2">หน่วยงาน</p>
                  <v-select
                    v-model="departmentSelect"
                    :items="departmentItems"
                    item-text="description"
                    item-value="id"
                    no-data-text="ไม่พบข้อมูล"
                    label="เลือกหน่วยงาน"
                    class="card-border"
                    flat
                    solo
                    hide-details
                    multiple
                    chips
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip>
                        <span>{{ item.name_th }}</span>
                      </v-chip>
                      <!-- <span
                        v-if="index === 1"
                        class="grey--text caption"
                      >(และอื่นๆ อีก {{ departmentSelect.length - 1 }} รายการ)</span> -->
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item ripple @click="toggleSelectAllDepartment">
                        <v-list-item-action>
                          <v-icon :color="departmentSelect.length > 0 ? 'primary base' : ''">{{
                            departmentSelecticon
                          }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>เลือกทั้งหมด</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs12>
                  <p class="subtitle-2 mt-10 mb-2">รหัส/ชื่อสายทาง</p>
                  <v-text-field
                    hide-details
                    label="ใส่รหัส / ชื่อสายทาง "
                    placeholder="ใส่รหัส / ชื่อสายทาง"
                    v-model="road"
                    class="card-border"
                    clearable
                    my-auto
                    solo
                    flat
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <p class="subtitle-2 mt-10 mb-2">จำนวนผู้เสียชีวิต</p>
                  <v-flex xs12>
                    <v-text-field
                      hide-details
                      suffix="ราย"
                      label="จำนวนผู้เสียชีวิต"
                      placeholder="ใส่จำนวนผู้เสียชีวิต"
                      v-model="deathcount"
                      class="card-border"
                      clearable
                      my-auto
                      solo
                      flat
                    ></v-text-field>
                  </v-flex>
                </v-flex>
                <v-flex xs12>
                  <p class="subtitle-2 mt-10 mb-2">จำนวนผู้บาดเจ็บ</p>
                  <v-flex xs12>
                    <v-text-field
                      hide-details
                      suffix="ราย"
                      label="จำนวนผู้บาดเจ็บ"
                      placeholder="ใส่จำนวนผู้บาดเจ็บ"
                      v-model="woundcount"
                      class="card-border"
                      clearable
                      my-auto
                      solo
                      flat
                    ></v-text-field>
                  </v-flex>
                </v-flex>
                <v-flex xs12>
                  <p class="subtitle-2 mt-10 mb-2">ประเภทสายทาง</p>
                  <v-select
                    v-model="roadtype"
                    :items="roadtypeItem"
                    item-text="name"
                    item-value="id"
                    no-data-text="ไม่พบข้อมูล"
                    label="เลือกประเภทสายทาง"
                    class="card-border"
                    flat
                    solo
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <p class="subtitle-2 mt-10 mb-2">มูลเหตุสันนิษฐานเบื้องต้น</p>
                  <v-select
                    v-model="cause"
                    :items="causeselectItem"
                    item-text="name"
                    item-value="id"
                    no-data-text="ไม่พบข้อมูล"
                    label="เลือกมูลเหตุสันนิษฐานเบื้องต้น"
                    class="card-border"
                    flat
                    solo
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <p class="subtitle-2 mt-10 mb-2">ลักษณะบริเวณ</p>
                  <v-select
                    v-model="surround"
                    :items="surroundselectItem"
                    item-text="name"
                    item-value="id"
                    no-data-text="ไม่พบข้อมูล"
                    label="เลือกลักษณะบริเวณ"
                    class="card-border"
                    flat
                    solo
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <p class="subtitle-2 mt-10 mb-2">ประเภทยานพาหนะ</p>
                  <v-select
                    v-model="cartype"
                    :items="cartypeselectItem"
                    item-text="name"
                    item-value="id"
                    no-data-text="ไม่พบข้อมูล"
                    label="เลือกประเภทยานพาหนะ"
                    class="card-border"
                    flat
                    solo
                    hide-details
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs6 class="pr-4" v-show="peroidToggle == 'event'">
              <p class="subtitle-2 mt-10 mb-2">ปี พ.ศ.</p>
              <v-select
                v-model="yearSelect"
                :items="yearItems"
                item-text="name"
                item-value="id"
                no-data-text="ไม่พบข้อมูล"
                label="เลือกปี"
                class="card-border"
                flat
                solo
                hide-details
              ></v-select>
            </v-flex>
            <v-flex xs6 v-show="peroidToggle == 'event'">
              <p class="subtitle-2 mt-10 mb-2">เทศกาล</p>
              <v-select
                v-model="eventSelect"
                :items="eventItems"
                item-text="name"
                item-value="id"
                :return-object="true"
                no-data-text="ไม่พบข้อมูล"
                label="เลือกเทศกาล"
                class="card-border"
                flat
                solo
                hide-details
              ></v-select>
            </v-flex>
            <v-flex
              v-if="isLogin || !role"
              xs3
              class="mt-8 mb-2 d-flex align-center flex-column flex-sm-row"
            >
              <v-btn
                :block="$vuetify.breakpoint.xsOnly"
                v-show="isLogin"
                rounded
                outlined
                width="120"
                color="primary"
                class="mt-2 order-1 order-sm-0"
                @click="gotoAccidentList"
                >ดูรายการ</v-btn
              >
            </v-flex>
            <v-flex xs3 class="mt-8 mb-2 d-flex align-center flex-column flex-sm-row">
              <v-btn
                v-show="role"
                :block="$vuetify.breakpoint.xsOnly"
                rounded
                outlined
                width="120"
                color="primary"
                class="mt-2 order-2 order-sm-0"
                @click="downloadCSV"
                >ดาวน์โหลด</v-btn
              >
            </v-flex>
            <v-flex v-if="!isLogin && role" xs3></v-flex>
            <v-flex
              xs6
              class="mt-8 mb-2 d-flex align-center justify-sm-end flex-column flex-sm-row"
            >
              <!--v-btn
                :block="$vuetify.breakpoint.xsOnly"
                rounded
                outlined
                width="120"
                color="primary"
                class="mt-2 order-1 order-sm-0"
                @click="cancelSearch"
              >ล้างข้อมูล</v-btn-->
              <v-btn
                :block="$vuetify.breakpoint.xsOnly"
                rounded
                width="120"
                color="primary"
                class="mt-2 ml-sm-2 order-0 order-sm-1"
                @click="confirmSearch"
                >ตกลง</v-btn
              >
            </v-flex>
          </v-layout>
        </v-tab-item>
        <v-tab-item class="pa-5">
          <v-card flat>
            <v-layout row wrap ma-0>
              <v-flex xs12>
                <p class="subtitle-1 mb-0">สรุปอุบัติเหตุบนโครงข่ายคมนาคม</p>
                <p class="subtitle-2 mb-0 mt-1">{{ getLastWeekPeriodDateWithText() }}</p>
                <v-data-table
                  :hide-default-header="$vuetify.breakpoint.xsOnly"
                  :headers="accidentHeaders"
                  :items="accidentAmount"
                  :items-per-page="10"
                  :footer-props="tableRowPerPageItems"
                  no-data-text="ไม่พบข้อมูล"
                  class="no-new-line-header elevation-1 mt-5"
                  :hide-default-footer="accidentAmountLength == 0"
                  :mobile-breakpoint="0"
                >
                  <template v-slot:footer.page-text="props">
                    {{ props.pageStart }} - {{ props.pageStop }} จาก
                    {{ props.itemsLength }}
                  </template>
                </v-data-table>
              </v-flex>
              <!--v-flex xs12 class="mt-10 mb-2 d-flex justify-center justify-sm-end">
                <v-btn :block="$vuetify.breakpoint.xsOnly" rounded width="120" color="primary">พิมพ์</v-btn>
              </v-flex-->
            </v-layout>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </template>
  </BaseFormCard>
</template>

<script>
import BaseFormCard from './BaseFormCard.vue';
import DatePicker from '../global/DatePicker.vue';

export default {
  name: 'SearchFormCard',
  components: {
    BaseFormCard,
    DatePicker
  },
  props: {
    map: {
      type: Object,
      default() {
        return {};
      }
    },
    isLogin: {
      type: Boolean
    },
    optionItems: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data: () => ({
    tableRowPerPageItems: {
      itemsPerPageOptions: [],
      itemsPerPageText: 'จำนวนแถวที่แสดง',
      disableItemsPerPage: true
    },
    searchTab: 0,
    roadtype: '',
    roadtypeItem: [],
    peroidToggle: 'date',
    //
    startDate: '',
    endDate: '',
    //
    provinceSelect: '',
    tambonSelect: '',
    amphoeSelect: '',
    departmentSelect: [],
    // roadSelect: '',
    yearSelect: '',
    eventSelect: '',
    //
    provinceItems: [],
    tambonItems: [],
    tambonAllItems: [],
    amphoeItems: [],
    amphoeAllItems: [],
    departmentItems: [],
    // roadItems: [],
    yearItems: [],
    eventItems: [],
    //
    road: '',
    accident: '',
    // for accident last 7 days
    accidentHeaders: [
      {
        text: 'หน่วยงาน',
        sortable: false,
        value: 'department_name'
      },
      { text: 'จำนวนอุบัติเหตุ', sortable: false, value: 'count' },
      { text: 'ผู้บาดเจ็บ', sortable: false, value: 'injury' },
      { text: 'ผู้เสียชีวิต', sortable: false, value: 'dead' }
    ],
    accidentAmount: [],
    deathcount: '',
    woundcount: '',
    causeselectItem: [],
    cause: '',
    surround: '',
    surroundselectItem: [],
    cartype: '',
    cartypeselectItem: [],
    today: null,
    role: localStorage.getItem('role')
  }),
  created() {
    this.getProvinceLists();
    // this.getAmphoeLists();
    // this.getTambonLists();
    this.getDepartmentLists();
    // this.getEventLists();
    this.getYearLists();
  },
  mounted() {
    this.today = this.utils.getLocalDate();
    this.getAccidentLastWeek();
    this.getYearLists();
  },
  methods: {
    deActivatebtn() {
      this.$refs['search-form-card'].closeClicked();
    },
    getYearLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/budget_year`;
      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.yearItems = response.data.data.map(Number);
            scope.yearItems.unshift('กำหนดเอง');
            // scope.yearSelect = response.data.data[0];
            this.initSearchDefaultDate();
          }
        })
        .catch(error => {
          scope.yearItems = [];
          console.log(error);
        });
    },
    initSearchDefaultDate() {
      // const { today, lastweek } = this.getLastWeekPeriodDate();

      // this.$refs.startDate.setDefaultData(
      //   `2020-03-03` //`${lastweek.year}-${lastweek.month}-${lastweek.day}`
      // );
      // this.$refs.endDate.setDefaultData(
      //   `2020-03-03` //`${today.year}-${today.month}-${today.day}`
      // );
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/festival/default`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            const defaultfes = response.data.data.filter(member => {
              return member.isdefault;
            })[0];
            scope.yearSelect = parseInt(defaultfes.end_date.split(' ')[0].substr(0, 4)) + 543;
            scope.$refs.startDate.setDefaultData(defaultfes.start_date.substr(0, 10));
            scope.$refs.endDate.setDefaultData(defaultfes.end_date.substr(0, 10));
            scope.getAccidentBySearch();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
      // this.searchTab = 1;
    },
    toggleSelectAllDepartment() {
      this.$nextTick(() => {
        if (this.selectAlldepartment) {
          this.departmentSelect = [];
        } else {
          this.departmentSelect = [];
          this.departmentItems.forEach(element => {
            this.departmentSelect.push(element.id);
          });
        }
      });
    },
    getProvinceLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/province`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.provinceItems = response.data.data;
            scope.provinceItems.unshift({ id: '', name: 'เลือกทุกจังหวัด' });
          }
        })
        .catch(function(error) {
          scope.provinceItems = [];
          console.log(error);
        });
    },
    getAmphoeLists() {
      // if (!this.provinceSelect) return;

      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/amphoe/${this.provinceSelect}`;
      // const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/amphoe/0`;

      // if (scope.amphoeAllItems.length == 0) {
      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            // scope.amphoeItems = response.data.data;

            // scope.amphoeAllItems = response.data.data;
            if (scope.provinceSelect) {
              scope.amphoeItems = response.data.data;
              scope.amphoeItems.unshift({ id: '', name: 'เลือกทุกอำเภอ' });
              // scope.amphoeAllItems.forEach(function(obj) {
              //   if (scope.provinceSelect == obj.province) {
              //     scope.amphoeItems.push(obj);
              //   }
              // });
            }

            // if (scope.amphoeTempId) {
            //   scope.amphoeItems.forEach(function (obj) {
            //     if (scope.amphoeTempId == obj.id) {
            //       scope.amphoeSelect = obj;
            //     }
            //   });

            //   scope.amphoeTempId = null;
            //   scope.getTambonLists();
            // }
          }
        })
        .catch(function(error) {
          scope.amphoeItems = [];
          console.log(error);
        });
      // } else if (scope.provinceSelect) {
      //   scope.amphoeItems = [];
      //   scope.amphoeAllItems.forEach(function(obj) {
      //     if (scope.provinceSelect == obj.province) {
      //       scope.amphoeItems.push(obj);
      //     }
      //   });
      // }
    },
    getTambonLists() {
      // if (!this.provinceSelect || !this.amphoeSelect) return;

      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/tambon/${this.provinceSelect}/${this.amphoeSelect}`;
      // const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/tambon/0`;

      // if (scope.tambonAllItems.length == 0) {
      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            // scope.tambonAllItems = response.data.data;
            if (scope.provinceSelect && scope.amphoeSelect) {
              scope.tambonItems = response.data.data;
              scope.tambonItems.unshift({ id: '', name: 'เลือกทุกตำบล' });
              //   scope.tambonAllItems.forEach(function(obj) {
              //     if (
              //       scope.provinceSelect.id == obj.province &&
              //       scope.amphoeSelect.id == obj.amphoe
              //     ) {
              //       scope.tambonItems.push(obj);
              //     }
              //   });
            }
          }
        })
        .catch(function(error) {
          scope.tambonItems = [];
          console.log(error);
        });
      // } else if (scope.provinceSelect && scope.amphoeSelect) {
      //   scope.tambonItems = [];
      //   scope.tambonAllItems.forEach(function(obj) {
      //     if (scope.provinceSelect == obj.province && scope.amphoeSelect == obj.amphoe) {
      //       scope.tambonItems.push(obj);
      //     }
      //   });
      // }
    },
    getDepartmentLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/department`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.departmentItems = response.data.data;
            // if (scope.departmentItems.length > 0)
            //   scope.departmentItems.unshift({
            //     id: 0,
            //     name: '',
            //     description: 'เลือกทุกหน่วยงาน'
            //   });
            const defaultDepartment = scope.departmentItems.filter(member => {
              return member.in_mot;
            });
            defaultDepartment.forEach(element => {
              scope.departmentSelect.push(element.id);
            });
          }
        })
        .catch(function(error) {
          scope.departmentItems = [];
          console.log(error);
        });
    },
    getAccidentLastWeek() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/map/accident_lastweek`;

      this.axios
        .get(url)
        .then(response => {
          // console.log(response);
          if (response.status === 200 && response.data.data) {
            if (response.data.data.report) {
              scope.accidentAmount = response.data.data.report;
              scope.accidentAmount.map(dept => {
                const departmentData = response.data.data.accident.filter(
                  data => data.department == dept.department
                );
                dept.dead = departmentData.reduce((sum, item) => sum + item.dead, 0);
                dept.injury = departmentData.reduce((sum, item) => sum + item.injury, 0);
                dept.count = departmentData.reduce((sum, item) => sum + 1, 0);
                return dept;
              });
            }
            // if (response.data.data.accident) {
            //   scope.accidentPin = response.data.data.accident;
            //   scope.$emit('pin-change', scope.accidentPin);
            // }
          }
        })
        .catch(function(error) {
          scope.accidentAmount = [];
          console.log(error);
        });
    },
    getAccidentBySearch(fromDownload = false) {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/map/accident_by_search`;
      scope.lastestSearchCondition = scope.searchParams;
      this.axios
        .get(url, {
          params: scope.searchParams
        })
        .then(response => {
          if (response.status === 200 && response.data.data) {
            let { data } = response.data;
            // let result = [];
            // console.warn(this.deathcount + ' : ' + this.woundcount);
            if (scope.deathcount != '') {
              data = data.filter(member => {
                return member.dead == scope.deathcount;
              });
            }
            if (scope.woundcount != '') {
              data = data.filter(member => {
                return member.injury == scope.woundcount;
              });
            }
            scope.accident = data;
            scope.$emit('pin-change', data);
            if (fromDownload) this.downloadCSV();
          }
        })
        .catch(function(error) {
          scope.accident = [];
          scope.$emit('pin-change', []);
          console.log(error);
        });
    },
    getLastWeekPeriodDateWithText() {
      const lastWeek = new Date(new Date() - 1000 * 60 * 60 * 24 * 6);
      return `วันที่ ${this.utils.formatToDateThai(lastWeek)} ถึง ${this.utils.formatToDateThai(
        new Date()
      )}`;
    },
    cancelSearch() {
      this.$refs['search-form-card'].closeClicked();
    },
    confirmSearch() {
      this.$refs['search-form-card'].closeClicked();
      this.getAccidentBySearch();
    },
    gotoAccidentList() {
      localStorage.setItem('accidentListStDate', this.startDate);
      localStorage.setItem('accidentListEdDate', this.endDate);
      localStorage.setItem('accidentListProvince', this.provinceSelect);
      localStorage.setItem('accidentListDepartment', this.departmentSelect.join(','));
      localStorage.setItem('accidentListRoad', this.road);
      this.$emit('goto-list');
    },
    downloadCSV() {
      if (this.searchParams != this.lastestSearchCondition) {
        const response = this.getAccidentBySearch(true);
      } else {
        let accidentcount = this.accident.length;
        const csv = [];
        while (accidentcount--) {
          const data = this.accident[accidentcount];
          csv.unshift(
            [
              data.id,
              data.department,
              data.route_code,
              data.controlsection,
              data.km,
              data.route_name,
              data.accident_date,
              data.accident_time,
              data.vehicle,
              data.accident_pattern_code,
              data.accident_pattern,
              data.cause_main,
              data.surround_character,
              data.dead,
              data.injury,
              data.damage,
              data.location.latitude,
              data.location.longitude,
              data.distance
            ].map(x => '"' + (x ? x.toString().replace(/"/g,'""') : '') + '"').join(',')
          );
        }
        csv.unshift(
          [
            'id',
            'department',
            'route_code',
            'controlsection',
            'km',
            'route_name',
            'accident_date',
            'accident_time',
            'vehicle',
            'accident_pattern_code',
            'accident_pattern',
            'cause_main',
            'surround_character',
            'dead',
            'injury',
            'damage',
            'latitude',
            'longitude',
            'distance'
          ].join(',')
        );
        this.download(`accident_${this.today.split('-').join('')}.csv`, csv.join('\n'));
      }
    },
    download(filename, text) {
      const element = document.createElement('a');
      element.setAttribute(
        'href',
        `data:text/csv;charset=utf-8,${encodeURIComponent(`\uFEFF${text}`)}`
      );
      element.setAttribute('download', filename);
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    changeDate(period) {
      if (period) {
        if (period.startDate != this.startDate) {
          this.$refs.startDate.setDefaultData(period.startDate);
        }
        if (period.endDate != this.endDate) {
          this.$refs.endDate.setDefaultData(period.endDate);
        }
      }
    }
  },
  watch: {
    // searchTab(val) {
    //   if (val === 1) {
    //     this.$emit('pin-change', this.accidentPin);
    //   }
    // },
    peroidToggle(value) {
      if (value == 'event' && this.eventSelect && this.eventSelect.start_date
        && (this.eventSelect.start_date.substr(0, 10) != this.startDate
        || this.eventSelect.end_date.substr(0, 10) != this.endDate)) {
          this.yearSelect = this.yearItems[0];
      }
    },
    provinceSelect(val) {
      this.amphoeSelect = '';
      this.amphoeItems = [];
      if (val != '') {
        this.getAmphoeLists();
      }
    },
    amphoeSelect(val) {
      this.tambonSelect = '';
      this.tambonItems = [];
      if (val != '') {
        this.getTambonLists();
      }
    },
    yearSelect() {
      if (isNaN(this.yearSelect)) {
        this.eventItems = ['กำหนดเอง'];
        this.eventSelect = this.eventItems[0];
      }
      else {
        const scope = this;
        const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/festival/${this.yearSelect -
          543}`;
        this.axios
          .get(url)
          .then(response => {
            scope.eventItems = response.data.data;
            const defaultEvent = scope.eventItems.filter(event => event.isdefault);
            if (defaultEvent.length > 0) {
              scope.eventSelect = defaultEvent[0];
            }
            else {
              scope.eventSelect = scope.eventItems[0];
            }
          })
          .catch(error => {
            scope.eventItems = [];
            console.log(error);
          });
      }
    },
    optionItems(val) {
      if (val.cause_main) {
        this.causeselectItem = val.cause_main.slice();
        this.causeselectItem.unshift({ id: '', name: 'เลือกทั้งหมด' });
      }
      if (val.surround_character) {
        this.surroundselectItem = val.surround_character.slice();
        this.surroundselectItem.unshift({ id: '', name: 'เลือกทั้งหมด' });
      }
      if (val.vehicle) {
        this.cartypeselectItem = val.vehicle.slice();
        this.cartypeselectItem.unshift({ id: '', name: 'เลือกทั้งหมด' });
      }
      if (val.road_type) {
        this.roadtypeItem = val.road_type.slice();
        this.roadtypeItem.unshift({ id: '', name: 'เลือกทั้งหมด' });
      }
    },
    eventSelect(val) {
      if ([this.$refs.startDate, this.$refs.endDate, this.eventSelect, this.eventSelect.start_date].indexOf(undefined) == -1) {
        this.$refs.startDate.setDefaultData(val.start_date.substr(0, 10));
        this.$refs.endDate.setDefaultData(val.end_date.substr(0, 10));
      }
    }
  },
  computed: {
    accidentAmountLength() {
      return this.accidentAmount.length;
    },
    searchParams() {
      const params = new URLSearchParams();
      if (this.peroidToggle === 'date' || !this.eventSelect.start_date) {
        params.append('start_date', this.startDate == null ? '' : this.startDate);
        params.append('end_date', this.endDate == null ? '' : this.endDate);
        params.append('province', this.provinceSelect == null ? '' : this.provinceSelect);
        params.append('amphoe', this.amphoeSelect == null ? '' : this.amphoeSelect);
        params.append('tambon', this.tambonSelect == null ? '' : this.tambonSelect);
        params.append('department', !this.departmentSelect ? '' : this.departmentSelect.join(','));
        params.append('road', this.road == null ? '' : this.road);
        params.append('cause_main', this.cause == null ? '' : this.cause);
        params.append('surround_character', this.surround == null ? '' : this.surround);
        params.append('vehicle_type', this.cartype == null ? '' : this.cartype);
        params.append('road_type', this.roadtype == null ? '' : this.roadtype);
      } else {
        params.append(
          'start_date',
          this.eventSelect.start_date == null ? '' : this.eventSelect.start_date.substr(0, 10)
        );
        params.append(
          'end_date',
          this.eventSelect.end_date == null ? '' : this.eventSelect.end_date.substr(0, 10)
        );
      }

      return params;
    },
    selectAlldepartment() {
      return this.departmentSelect.length === this.departmentItems.length;
    },
    selectSomedepartment() {
      return this.departmentSelect.length > 0 && !this.selectAlldepartment;
    },
    departmentSelecticon() {
      if (this.selectAlldepartment) return 'mdi-close-box';
      if (this.selectSomedepartment) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    }
  }
};
</script>
<style lang="scss" scoped>
.toggle-active {
  background-color: #4f3f40;
  border: #4f3f40 1px solid;
  color: white !important;
}
.toggle-normal {
  border: #4f3f40 1px solid !important;
  color: #4f3f40;
}
</style>
